import { createRouter, createWebHistory } from 'vue-router'
import { auth } from './guards'
import { useGlobalStore } from '@/stores/global.js'
import { useUserStore } from '@/stores/user.js'
import adminRoutes from '@/views/admin/routes.js'
import configurationRoutes from '@/views/configuration/routes.js'
import propertiesRoutes from '@/views/properties/routes.js'
import clientsRoutes from '@/views/clients/routes.js'
import companiesRoutes from '@/views/companies/routes.js'
import requestsRoutes from '@/views/requests/routes.js'
import communicationsRoutes from '@/views/communications/routes.js'
import reportsRoutes from '@/views/reports/routes.js'

const router = createRouter({
  history: createWebHistory(
    import.meta.env.BASE_URL
  ),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import ('@/views/Login.vue'),
      meta: { title: 'Login' }
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('@/views/ResetPassword.vue'),
      meta: { title: 'Reset Password' }
    },
    {
      path: '/auth/:provider/callback',
      name: 'oauth',
      component: () => import ('@/views/OAuth.vue'),
      meta: { title: 'SSO Authentication' },
      props: (route) => ({ provider: route.params.provider })
    },
    {
      path: '/',
      component: () => import('@/views/Default.vue'),
      redirect: '/dashboard',
      beforeEnter: [auth],
      children: [
        {
          path: 'dashboard',
          children: [
            {
              name: 'dashboard',
              path: '',
              component: () => import('../views/Dashboard.vue'),
              meta: { title: 'Dashboard' }
            }
          ]
        },
        {
          path: 'settings',
          children: [
            {
              name: 'settings',
              path: '',
              component: () => import('../views/Settings.vue'),
              meta: { title: 'Settings' }
            }
          ]
        },
        ...adminRoutes,
        ...configurationRoutes,
        ...propertiesRoutes,
        ...clientsRoutes,
        ...companiesRoutes,
        ...requestsRoutes,
        ...communicationsRoutes,
        ...reportsRoutes,
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const globalStore = useGlobalStore()
  const userStore = useUserStore()

  document.title = to.meta.title ? to.meta.title + ' | ' + import.meta.env.VITE_NAME : import.meta.env.VITE_NAME

  if (globalStore.redirect) {
    let redirect = globalStore.redirect
    globalStore.redirect = null
    next(redirect)
  }

  if (window.Maker) {
    if (['stats-portal-capture'].includes(to.name)) {
      window.Maker.hide()
    } else {
      window.Maker.show()
    }
  }

  if (['reset-password', 'register', 'invite', 'join', 'oauth'].includes(to.name)) {
    next()
  } else if (!userStore.token && to.name !== 'login') {
    next('login')
  } else if (userStore.token && ['register', 'invite', 'login'].includes(to.name)) {
    next('dashboard')
  } else {
    next()
  }
})

router.onError((error) => {
  const chunkLoadFailedRegex = /Loading chunk \d+ failed|Failed to fetch dynamically imported module|Failed to load module script.*MIME type.*text\/html/

  if (chunkLoadFailedRegex.test(error.message)) {
    console.error('Dynamic import failed. Reloading...', error.message)
    window.location.href = window.location.href + '?v=' + Date.now()
  }
})

export default router
